import { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

export type SetNpiRequest =
  paths['/v2/users/me/npi']['put']['requestBody']['content']['application/json'];

export type SetNpiResponse =
  paths['/v2/users/me/npi']['put']['responses']['200']['content']['application/json'];

export type SetNpiReferralExtras = {
  referredById?: number;
  referredByPrefix?: string;
  referredByName?: string;
};

export type SetNpiResult = SetNpiResponse['data'] & SetNpiReferralExtras;

/**
 * Set NPI for user account during onboarding
 *
 * Complete account onboarding by setting NPI number. NPI must be pre-validated
 * via GET /v2/providers/{npi}. Validates uniqueness, fetches NPPES data, and
 * sets validNpi=true. Idempotent operation (can only be set once).
 */
export async function setNpi(body: SetNpiRequest): Promise<SetNpiResult | undefined> {
  const { data } = await fetchClient.PUT('/v2/users/me/npi', {
    body,
  });

  if (!data?.data) {
    return undefined;
  }

  const referral = data.data?.referrer
    ? {
        referredById: data.data.referrer.id,
        referredByPrefix: 'Referred by',
        referredByName: `${data.data.referrer.firstName} ${data.data.referrer.lastName}`,
      }
    : {};

  return {
    ...data.data,
    ...referral,
  } as SetNpiResult;
}
